<div id="teacher-classes">
    <div class="classes-container" [class.is-mobile]="isMobile">
      <app-header (height)="onGetHeight($event)"></app-header>
      <mat-sidenav-container class="sidenav-container">
        <mat-sidenav-content>
          <router-outlet></router-outlet>
        </mat-sidenav-content>
      </mat-sidenav-container>
    </div>
  </div>
  
  <app-loading [loading]="loading"></app-loading>
  